// 公用部分
export default {
    totals: 'общий',
    phoneNumber: 'Номер телефона',
    add: 'прибавление',
    new: 'новый',
    edit: 'редактирование',
    del: 'Удалить',
    delete: 'Удалить',
    BD: 'пакетное удаление',
    cancel: 'ликвидация',
    ok: 'OK',
    save: 'устанавление',
    numbering: 'Нумерация',
    remarks: 'примечание',
    details: 'Подробности',
    description: 'описание',
    start: 'начать',
    complete: 'выполнение',
    return: 'возвращение',
    preservation: 'хранение',
    upload: 'загрузить',
    download: 'загрузка',
    bulkDownload: 'Пакетная загрузка',
    getSuccess: 'успешно приобрететь',
    setSuccess: 'успешно установлеть',
    uploadSuccess: 'загрузить успешно',
    editSuccess: 'редактировать успешно',
    addSuccess: 'добавить успешно',
    RC: 'Чтение завершено',
    tip: 'Подсказка',
    warning: 'предостережение',
    send: 'Был отправлен',
    saved: 'Сохранено',
    deleteSuccessful: 'удалено',
    deleteSuccess: 'успешно удалить',
    on: 'открыто',
    off: 'выключать',
    success: 'успеха',
    failure: 'неуспех',
    odifiedSuccess: 'успешно изменить',
    selectUAV: 'Пожалуйста, выберите дрон',
    tip_pleaseEnterLng: 'Пожалуйста, введите долготу',
    tip_pleaseEnterLat: 'Пожалуйста, введите широту',
    tip_pleaseEnterAlt: 'Пожалуйста, введите высоту',
    tip_lngFormatErr: 'Неверный формат долготы, пожалуйста, введите еще раз',
    tip_latFormatErr: 'Ошибка формата широты, введите еще раз',
    tip_altFormatErr: 'Ошибка формата высоты, пожалуйста, введите еще раз',
    tip_altMaxErr: "Высота превышает максимальную высоту системы 9999",
    lngFormat: 'диапазон долготы -180 ~ 180, повторите. ',
    latFormat: 'широта -90 ~ 90, пожалуйста, введите снова.',
    confirmRevision: 'Вы хотите изменить?',
    reset: 'Сброс настроек',
    search: 'искать',
    query: 'узнавание',
    filter: 'фильтр',
    operation: 'операция',
    use: 'использование',
    returnstation: 'Вернуться на наземную станцию',
    ND: 'Нет данных',
    time: 'время',
    startTime: 'время начала',
    to: 'до',
    loading: 'Загрузка',
    empty: 'Пустой',
    selectAll: 'выбрать все',
    export: 'Экспорт',
    select: 'выбрать',
    lng: 'долгота',
    lat: 'широта',
    folder: 'папка',
    file: 'файл',
    height: 'высота',
    altitude: 'высота',
    relativeHeight: 'Относительная высота',
    elevation: 'Высота',
    speed: 'скорость',
    groundSpeed: 'Скорость относительно земли',
    airspeed: 'скорость полета',
    radius: 'радиус',
    setUp: 'Настраивать',
    digitalMap: 'цифровая карта',
    satelliteMap: 'спутниковая карта',
    level: '{name} уровень',
    online: 'Oнлайн {0}',
    offline: 'Oфлайн {0}',
    total: 'Всего {0}',
    uav: 'дрон',
    rtk: 'RTK',
    baseStation: 'базовая станция',
    weatherStation: 'Mетеостанция',
    noFlyZone: 'бесполетная зона',
    restrictedFlyArea: 'запретная зона для полетов',
    all: 'Bсе',
    taskNumber: 'номер задачи',
    creationTime: 'время создания',
    founder: 'основатель',
    deadline: 'крайний срок',
    startingTime: 'Время начала',
    completeTime: 'Полное время',
    endTime: 'Время окончания',
    workLocation: 'расположение работы',
    taskType: 'тип задачи',
    state: 'состояние',
    mapView: 'Просмотр карты',
    copy: 'копировать',
    paste: 'Вставить',
    saveAndExit: 'Сохранить и выйти',
    hide: 'скрывать',
    show: 'показывать',
    notInstalled: 'Не установлен',
    unknown: 'неизвестный',

    // 气象站相关
    windSpeed: 'скорость ветра',
    windDirection: 'направление ветра',
    temperature: 'температура',
    humidity: 'влажность',
    airPressure: 'давление воздуха',

    // 任务类型
    pointReconnaissance: 'точечная разведка',
    regionalReconnaissance: 'Региональная разведка',
    orthophoto: 'положительное изображение',
    tiltPhotography: 'перспективное фотографирование',
    logisticsTransportation: 'логистический транспорт',

    tip_del: 'Вы уверены, что хотите удалить?',
    tip_revoke: 'Вы действительно хотите отменить?',
    tip_recover: 'Вы уверены в восстановлении?',
    rightClickDelete: 'щелкните правой кнопкой мыши удалить меня',
    tip_deletePermanently: 'Эта операция приведет к безвозвратному удалению данных. Продолжить?',
    tip_SDT: 'Выберите дату и время',
}